import { render, staticRenderFns } from "./Wind.vue?vue&type=template&id=791635ef&"
import script from "./Wind.vue?vue&type=script&lang=js&"
export * from "./Wind.vue?vue&type=script&lang=js&"
import style0 from "./Wind.vue?vue&type=style&index=0&id=791635ef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports